var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count__wrap"},[_c('div',{staticClass:"count__date"},[_vm._v("距结束"+_vm._s(_vm.countdown.days)+"天")]),_vm._v(" "),_c('div',{staticClass:"count__time"},[_c('span',[_vm._v(_vm._s(_vm.countdown.hours))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.countdown.minutes))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.countdown.seconds))])])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/activity/2021525/count-down.vue?vue&type=template&id=3a5b6e03&scoped=true&
// module id = null
// module chunks = 